import React from 'react'
import Home from './screens/home'

export default function hello() {
  return (
    <div><Home/></div>
  )
}
